module.exports = __webpack_public_path__ + "static/media/thumbnail.3d3e1a9a.jpg";